export type BulkOpSourceType =
  | 'User'
  | 'Group'
  | 'OrgUnit'
  | 'Domain'
  | 'gPanel_Role';

export interface SourceTypeOption {
  value: BulkOpSourceType;
  label: string;
  notApplicable: boolean;
}

export function getSourceTypeOptions(
  bulkImportTypeName: string
): SourceTypeOption[] {
  const isType = (...names: string[]) => names.includes(bulkImportTypeName);

  return [
    {
      value: 'User',
      label: 'User',
      notApplicable: isType(
        'groupDeletion',
        'clearUsersFromGroup',
        'groupImport',
        'gPanelRoleImport',
        'groupMemberSettingsUpdate'
      ),
    },
    {
      value: 'Group',
      label: 'Group',
      notApplicable: isType(
        'removeUsersShares',
        'sharedContactImport',
        'removeSharesFromUser',
        'gPanelRoleImport',
        'usersVacationResponder'
      ),
    },
    {
      value: 'OrgUnit',
      label: 'Org Unit',
      notApplicable: isType(
        'removeUsersShares',
        'sharedContactImport',
        'removeSharesFromUser',
        'gPanelRoleImport',
        'groupDeletion',
        'clearUsersFromGroup',
        'calendarPermissionSettings',
        'usersVacationResponder',
        'signatureTemplateBlackListStatus',
        'groupImport',
        'groupMemberSettingsUpdate'
      ),
    },
    {
      value: 'Domain',
      label: 'Domain',
      notApplicable: !isType(
        'signatureTemplateBlackListStatus',
        'groupImport',
        'calendarPermissionSettings',
        'labelDriveDocs'
      ),
    },
    {
      value: 'gPanel_Role',
      label: 'Role',
      notApplicable: !isType('gPanelRoleImport'),
    },
  ];
}
